/**
 * iHeart CNTRL design tokens. Source of truth for both Tailwind config and
 * any runtime style needs. Keep this file pure (no React imports) so it can
 * be consumed from the API too if it ever needs to render branded emails.
 */
export const brand = {
    name: 'iHeart CNTRL',
    tagline: 'Social Scheduling. Total Control.',
    colors: {
        pink: '#ff27a8',
        blue: '#5170ff',
        body: '#545454',
        bg: '#ffffff',
        border: '#e5e7eb',
        muted: '#f5f5f5',
        success: '#10b981',
        warning: '#f59e0b',
        danger: '#ef4444',
        info: '#3b82f6',
    },
    gradient: {
        primary: 'linear-gradient(135deg, #ff27a8 0%, #5170ff 100%)',
        primaryReverse: 'linear-gradient(315deg, #ff27a8 0%, #5170ff 100%)',
    },
    motion: {
        grow: 1.05,
        spring: { type: 'spring', stiffness: 300, damping: 20 },
    },
    radius: {
        sm: '6px',
        md: '12px',
        lg: '16px',
        full: '9999px',
    },
};
//# sourceMappingURL=brand.js.map